/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 *  Operations 
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { globalEngine, ModuleManager } from "./Init";
import { findObjectSize } from "./common";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
function CreateDataOperations()
{
	var  operations = 
	{
	    /*  Applies an operation configuration to a value
         *
         *  PARAMS:
         *      value: Value to be operated on
         *      operationConfig: Defines the operation name and any required params
         * 
         *  RETURN:
         *      postOperation value (null if exception caught)
         *
         */
	    "apply": function (value, operationConfig)
	    {
	        try
	        {
	            // this._logInfo('apply: called with value(' + value + '), operationConfig(' + JSON.stringify(operationConfig) + ')');
	            if (!operationConfig)
	            {
	                return value;
	            }
	            return this[operationConfig['name']](value, operationConfig['params']);
	        }
	        catch (e)
	        {
	            this._logError('operations:apply: Excption caught(' + e.message + '. Val(' + value + '), operationConfig(' + JSON.stringify(operationConfig) + ')');
	            return null;
	        }

	    },

	    /* No operation
        */
	    "noop": function (value) { return value; },

	    /* Equal operation
        */
	    "equal": function (value,param) { return value == param; },

	    /* Valid value operation
        */
	    "isValueValid": function (value) 
	    {
	     	return (value != "[not assigned]") && (value != "[ruleMismatch]") && (value != "[ruleError]") ; 
	 	},

	    /* Returns true if value is not null, false otherwise
        */
	    "notNull": function (value) { return (value != null); },

	    /* Return value at index params
        */
		"at": function (value, params)
		{
		    return value[params];
		},
		/* Combines day, month and year into a date
		*/
		"combineCustomDate": function(value,params)
		{
			//should be same size
			if(findObjectSize(value) != findObjectSize(params)){
				return null;
			}
			return value['InstalledYear']+'-'+value['InstalledMonth']+'-'+value['InstalledDate'];
		},

	    /* Splits value based on params and returns the result
        */
		"split": function (value, params)
		{
		    return value.split(params);
		},

	    /*  Return first not null item in values (values is expected to be an array or object)
        */
		"first" : function (values)
		{
		    for (var idx in values)
		    {
		        if (values[idx] != null)
		        {
		            return values[idx];
		        }
		    }
		    return null;
		},

	    /* Apply a mask operation between value and params
        */
		"mask" : function (value, params)
		{
		    return value & params;
		},

	    /* Applies logical OR between the values in array or object
        */
		"or": function (values)
		{
		    for (var idx in values)
		    {
		        if (values[idx])
		        {
		            return true;
		        }
		    }
		    return false;
		},

	    /* Applies logical AND between the values in array or object
        */
		"and": function (values)
		{
		    for (var idx in values)
		    {
		        if (!values[idx])
		        {
		            return false;
		        }
		    }
		    return true;
		},

	    /* Returns value*params
        */
		"multiply": function (value, params)
		{
		    return parseInt(value, 10) * params;
		},

	    /* Returns value/params
        */
		"divide": function (value, params)
		{
		    return parseInt(value, 10) / params;
		},

	    /* Joins value based on params (value is expected to be an array)
        */
		"join" : function (value, params)
		{
		    return value.join(params);
		},

		/*
		* Used to add "0x" to OS locale from windows WMI e.g cleanLocaleCode("0320") ==> "0x0320"
		*/
		"cleanLocaleCode": function(value,params)
		{
			try{
				if (value) 
				{
					//value should be a string
					if(typeof value != "string")
					{
						value = String(value);
					}

					//It's a 16 bit hex value,append 0x
					if (value.length == 4) {
						value = "0x" + value;
					}
				}
			}catch(e)
			{
				this._logError("splitLocaleCode exception: "+e.message);
			}

			return value;
		},
	    /* Returns number of days until a value
        */
		"daysTo": function(value)
		{
		    if (typeof value.getTime !== "function" )
		    {
		        this._logError('daysTo: value is not datetime object (' + value + ')');
                return null;
		    }
		    return this._getDaysBetween(value, null);
		},

	    /* Returns a value rounded up/down
        * params is in the form {multiple: multipleValue, roundUp: flag to detonate rounding up or down}
        */
		"round": function (value, params)
		{
		    try
		    {
		        if (!params)
		        {
		            return value;
		        }

		        var multiple = params['multiple'];
		        var roundUp = params['roundUp'];
		        if (!multiple)
		        {
		            return value;
		        }

		        var roundDown = parseInt((value / multiple), 10) * multiple;
		        if (roundUp == true)
		        {
		            return roundDown + multiple;
		        }

		        return roundDown;
		    }
		    catch (e)
		    {
		        this._logError('roundtoNearestMultiple: { numToRound: ' + value + ', multiple: ' + multiple + ', roundUp: ' + roundUp + ' } exception caught with message: ' + e.message);
		        return value;
		    }
		},

	    /* Returns time since a value
        * params can be used to return time in (days, minutes, hours)
        */
		"timeSince": function (value, params)
		{
		    if ((value ==  null) || (typeof value.getTime !== "function"))
		    {
		        this._logError('daysTo: value is not datetime object (' + value + ')');
		        return null;
		    }

		    var one_minute_ms = 1000 * 60;
		    var one_hour_ms = one_minute_ms * 60;
		    var one_day_ms = one_hour_ms * 24;

		    var timeNow = Date.now();

		    var difference_ms = timeNow - value.getTime();

		    if (!params || params === 'days')
		    {
		        return parseInt(difference_ms / one_day_ms, 10); // days
		    }

		    if (params === 'hours')
		    {
		        return parseInt((difference_ms % one_day_ms) / one_hour_ms, 10); // hours
		    }

		    if (params === 'minutes')
		    {
		        return parseInt(((difference_ms % one_day_ms) % one_hour_ms) / one_minute_ms, 10); // minutes
		    }

		    return null;
		},

		/* Transforms the value based on the params
		*/
		"transform": function(value, params)
		{
			return params[value];
		},


	    /* Converts a Date object to epoch
        */
		"dateToEpoch": function(value)
		{
		    return value.getTime() / 1000;
		},

	    /* Converts a epoch to ISO date string
        */
		"epochToISODate": function(value)
		{
		    var dateValue = new Date(0); 
			dateValue.setUTCSeconds(value);
			return dateValue.toISOString();
		},

	    /* Converts a Date object to ISO string
        *  if params === dataTime, the function will return ISO datetime format
        */
		"dateToISO": function(value, params)
		{
		    if (params && params === 'dateTime')
		    {
		        return value.toISOString();
		    }
		    return value.toISOString(true);
		},

	    /* Converts WSS date format to Date object
        */
		"wssDateToDate": function (value)
		{
		    if (!value || (8 != value.length))
		    {
		        return null;
		    }

		    var year = parseInt(value.substr(0, 4), 10);
		    var month = parseInt(value.substr(4, 2), 10);
		    var day = parseInt(value.substr(6, 2), 10);
		    if (!year || !month || !day)
		    {
		        return null;
		    }

		    return new Date(year, month - 1, day);
		},
	    /*
        */
		"_getDaysBetween": function (date2, date1)
		{
		    try
		    {
		        //Get 1 day in milliseconds
		        var one_day = 1000 * 60 * 60 * 24;

		        // Convert both dates to milliseconds
		        var date2_ms = date2.getTime();

		        var date1_ms;
		        if (!date1)
		        {
		            date1_ms = Date.now();
		        }
		        else
		        {
		            date1_ms = date1.getTime();
		        }

		        // Calculate the difference in milliseconds
		        var difference_ms = date2_ms - date1_ms;

		        // Convert back to days and return
		        return parseInt((difference_ms / one_day), 10);
		    }
		    catch (e)
		    {
		        this._logError('Exception caught while calculating difference between dates: ' + e.message);
		    }

		    return null;
		},
		 // Map id to index in array (params)
	    "containsIn": function (value, params) {
	        var Ivalue = parseInt(value, 10);
	        if (params[Ivalue] !== undefined) {
	            return params[Ivalue];
	        }
	        return null;
	    },
		// Convert a date string (YYYYMMDDhhmmss) to iso date time
		"stringToISODate": function (value)
		{
			if (!value || (14 > value.length))
			{
				return null;
			}

			var year = parseInt(value.substr(0, 4), 10);
			var month = parseInt(value.substr(4, 2), 10);
			var day = parseInt(value.substr(6, 2), 10);
			var hour = parseInt(value.substr(8, 2), 10);
			var minute = parseInt(value.substr(10, 2), 10);
			var second = parseInt(value.substr(12, 2), 10);
			
			var invalidDates = !year || !month || !day || !hour || !minute || !second;
			if (invalidDates)
			{
				return null;
			}

			var isoDate = new Date(year, month - 1, day, hour, minute, second);
			return isoDate.toISOString();
		},

		"_logInfo": function (msg)
		{
		    logInformation('operations: ' + msg);
		},
		"_logError": function (msg)
		{
		    logError('operations: ' + msg);
		}

	};
	return operations;
}

ModuleManager.registerFactory("operations", CreateDataOperations);

//export  {CreateDataOperations};
//globalEngine.FactoryMap["operations"] =  CreateDataOperations;
